import styles from "./StarRating.module.css";

type Props = {
  value: number;          // 0..5
  max?: number;           // default 5
  size?: number;          // px, default 14
  showValue?: boolean;    // default true
  className?: string;
};

function clamp(n: number, min: number, max: number) {
  return Math.min(max, Math.max(min, n));
}

export default function StarRating({
  value,
  max = 5,
  size = 14,
  showValue = true,
  className,
}: Props) {
  const v = clamp(value, 0, max);
  const pct = (v / max) * 100;

  return (
    <span className={`${styles.root} ${className ?? ""}`}>
      <span
        className={styles.stars}
        style={{ ["--pct" as string]: `${pct}%`, ["--size" as string]: `${size}px` }}
        aria-label={`Rating ${v.toFixed(1)} out of ${max}`}
        role="img"
      >
        {/* background stars */}
        <span className={styles.back}>★★★★★</span>

        {/* filled stars */}
        <span className={styles.front} style={{ width: `var(--pct)` }}>
          ★★★★★
        </span>
      </span>

      {showValue && (
        <span className={styles.value}>{v.toFixed(1)}</span>
      )}
    </span>
  );
}
